import { render, staticRenderFns } from "./title-play-button.vue?vue&type=template&id=60a8ae6b&scoped=true"
import script from "./title-play-button.vue?vue&type=script&lang=js"
export * from "./title-play-button.vue?vue&type=script&lang=js"
import style0 from "./title-play-button.vue?vue&type=style&index=0&id=60a8ae6b&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8ae6b",
  null
  
)

export default component.exports